module.exports = __webpack_public_path__ + "static/media/no-portrait-poster.346d7d8e.png";